// import axios from 'axios';
export default {
  components: {},
  data() {
    return {
      isOrderManageDetail: this.$route.fullPath.indexOf('/CUSTOMIZED/ORDERMANAGEDETAIL') > -1,
      radioValue: '2',
      searchValue: '',
      tableConfig: {
        indexColumn: true,
        columns: [
          {
            title: '商品SKU',
            key: 'ECODE'
          },
          {
            title: 'SPU名称',
            key: 'PS_C_PRO_ENAME'
          },
          {
            title: '规格',
            key: 'SPEC'
          },
          {
            title: '颜色',
            key: 'colorName'
          },
          {
            title: '尺寸',
            key: 'sizeName'
          },
          {
            title: '是否为赠品',
            key: 'IS_GIFT'
          }
          // {
          //   key: 'skuEcode',
          //   title: $it('fL.barCode'), // 条码
          // },
          // {
          //   key: 'spuEcode',
          //   title: $it('tL.itemNo01'), // SPU编码
          // },
          // {
          //   key: 'spuEname',
          //   title: $it("tL.itemNo02"), // SPU名称
          // },
          // {
          //   key: 'skuEname',
          //   title: $it('fL.skuName'), // SKU名称
          // },
          // {
          //   key: 'brandEname',
          //   title: '品牌',
          // },
          // {
          //   key: 'classifyEname',
          //   title: '商品分类',
          // }
        ],
        data: [],
        selectionData: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '350', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        isShowSelection: true, // 是否显示checkedbox
        highlightRow: true, // 高亮单选必须结合它
        multiple: false //false 单选
      },
      formConfig: {
        formData: [
          {
            style: 'input', // 输入框类型
            label: '商品SKU', // 输入框前文字
            value: 'PS_C_SKU_ECODE', // 输入框的值
            width: '6',
            inputenter: () => {
              this.search();
            },
          },
          {
            style: 'dropSelect',
            width: '6',
            itemdata: {
              colid: 136292,
              colname: 'PS_C_PRO_ID', // 当前字段的名称
              fkdisplay: 'mrp', // 外键关联类型
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: '商品SPU', // 物流公司 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.PS_C_PRO_ID = e.pid.split(',');
            },
          },
          {
            style: 'dropSelect',
            width: '6',
            itemdata: {
              colid: 168733,
              colname: 'PS_C_SPEC1_ID', // 当前字段的名称
              fkdisplay: 'mrp', // 外键关联类型
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: '颜色', // 物流公司 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.PS_C_SPEC1_ID = e.pid.split(',');
            },
          },
          {
            style: 'dropSelect',
            width: '6',
            itemdata: {
              colid: 168734,
              colname: 'PS_C_SPEC2_ID', // 当前字段的名称
              fkdisplay: 'mrp', // 外键关联类型
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: '尺寸', // 物流公司 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.PS_C_SPEC2_ID = e.pid.split(',');
            },
          },
        ],
        formValue: {
          PS_C_SPEC1_ID: [],
          PS_C_SPEC2_ID: [],
          PS_C_PRO_ID: []
        }
      },
      businessButtonConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'left', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('btn.find'), // 查找
            type: 'primary',
            btnclick: () => {
              this.search()
            } // 按钮点击事件
          },
          {
            text: $it('btn.reset'), // 重置
            btnclick: () => {
              $utils.formEmpty(this, 'formConfig')
              this.search()
            } // 按钮点击事件
          }
        ],
      },
      data: [],
      currentSkuEcode: '',
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('com.cancel'), // 取消 按钮文本
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: $it('com.determine'), // 确定 按钮文本
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$route.params.tableName == 'OC_B_VIPCOM_RETURN_PO' ? this.ok() : this.confirm();
            } // 按钮点击事件
          },
        ]
      },
    };
  },
  props: {
    componentData: {
      type: Object
    },
    idArray: {
      type: Array,
      defalut: () => [],
    }
  },
  mounted() {
    console.log('componentData:', this.componentData);
    if (this.isOrderManageDetail) {
      this.tableConfig.pageShow = true
    }
  },
  methods: {
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectionData = selection;
     },
    // 单击某一行时触发
    onRowClick(row) {
      this.currentSkuEcode = row.ECODE
    },
    // 双击某行时触发
    onRowDblclick() { },
    // 分页change 事件
    pageChange(val) {
      console.log(val);
      this.tableConfig.current = val;
      this.search();
    },
    // 切换分页条数
    pageSizeChange(val) {
      console.log(val);
      this.tableConfig.pageSize = val;
      this.search();
    },
    tableDeleteDetail() { },
    // 搜索
    search() {
      // sku查询
      const self = this;
      // let data = {
      //   skuEcode: self.searchValue,
      //   size: this.tableConfig.pageSize || 10,
      //   current: this.tableConfig.current || 1,
      // }
      // axios({
      //   method: 'post',
      //   url: '/r3-ps/p/cs/ps/pro/v1/selectSkuProBySkuEcodeList',
      //   data,
      // }).then((res) => {
      //   self.tableConfig.data = res.data.data.records;
      //   self.tableConfig.total = res.data.data.total
      // })

      const data = {
        isBlur: 'N',
        psCSku: { ECODE: self.searchValue },
      };
      // 零售发货单-替换商品
      if (this.isOrderManageDetail) {
        data.psCSku.ECODE = this.formConfig.formValue.PS_C_SKU_ECODE
        for (let key in this.formConfig.formValue) {
          let val = this.formConfig.formValue[key]
          if (Array.isArray(val) && val.length && val[0] != '' || !Array.isArray(val) && val.length) {
            data[key] = val
          }
        }
        data.offSet = this.tableConfig.current;//开始页数
        data.limit = this.tableConfig.pageSize;//每页多少条
      }
      self.service.common.skuQuery(data).then(res => {
        if (res.data.code == 0) {
          // if (JSON.stringify(res.data.data) == '{}') {
          //   // 查询数据为空!
          //   this.$Message.warning($it('tip.r8'));
          //   return;
          // }
          if (res.data.data.data.length == 0) {
            // 查询数据为空!
            this.$Message.warning($it('tip.r8'));
            return;
          }

          let arr = res.data.data.data.map(i => {
            i.IS_GIFT = i.IS_GIFT == '0' ? '否' : '是'
            return i
          })
          // res.data.data.data[0].IS_GIFT = res.data.data.data[0].IS_GIFT == '0' ? '否' : '是';
          if (this.tableConfig.multiple) {
            let exist = self.tableConfig.data.some(i => i.PS_C_PRO_ECODE == res.data.data.data[0].PS_C_PRO_ECODE)
            if (!exist) {
              self.tableConfig.data.push(res.data.data.data[0])
              this.searchValue = ''
            }
          } else {
            self.tableConfig.data = arr;
          }
          this.isOrderManageDetail && (this.tableConfig.total = res.data.data.totleCount)
        } else {
          // sku查询失败!
          this.$Message.warning($it('tip.zt'));
        }
      });
    },
    // 替换
    async confirm() {
      console.log('self.tableConfig.data:', this.tableConfig.data);
      const self = this;
      if (self.tableConfig.data.length == 0) {
        // sku不能为空!
        self.$Message.warning($it('tip.cg'));
        return;
      }
      const param = {
        ids: self.componentData.ids,
        sku_code: this.isOrderManageDetail ? this.currentSkuEcode : self.tableConfig.data[0].ECODE,
        itemId: self.componentData.itemId,
        type: 1
      };

      // self.loading = true;
      try {
        const { data: { code, message, data } } = await this.service.orderCenter.bathChangeGoods(param);
        if (code == 0) {
          self.$Message.success(message);
          if (self.componentData.list) {
            self.$parent.$parent.$parent.getData();
          } else {
            if (self.$parent.$parent.$parent.reloadCus) self.$parent.$parent.$parent.reloadCus();
            if (self.$parent.$parent.$parent.$parent.autoRefresh) self.$parent.$parent.$parent.$parent.autoRefresh();
          }
          self.$parent.$parent.closeConfirm();
        } else {
          self.$parent.$parent.closeConfirm();
          self.$Modal.confirm({
            title: message,
            width: 500,
            render: h => h('Table', {
                props: {
                  columns: [
                    {
                      title: '提示信息',
                      key: 'message'
                    }
                  ],
                  data
                }
              })
          });
        }
      } catch (error) {
        self.loading = false;
      }
      // if (!this.currentSkuEcode) {
      //   // 请选中一条单据!
      //   self.$Message.warning($it('tip.d8'));
      //   return;
      // }
      // console.log(this.componentData);
      // let params = {
      //   orderList: this.componentData.orderList,
      //   skuEcodes: [this.componentData.oldSuk, this.currentSkuEcode],
      //   spuIds: this.componentData.spuIds
      // }
      // this.btnConfig.buttons[1].disabled = true;
      // const { data: { code, message, data } } = await this.service.orderCenter.replaceOrderByPro(params);
      // setTimeout(() => {
      //   this.btnConfig.buttons[1].disabled = false;
      // }, 5000);
      // console.log(code, message, data);
      // if (code === 0) {
      //   self.$Message.success(message);
      //   self.$parent.$parent.closeConfirm();
      //   self.$parent.$parent.$parent.$parent.$parent.getDetailsData();
      // } else if (code === -1) {
      //   this.$Modal.confirm({
      //     title: "message",
      //     width: 500,
      //     className: 'ark-dialog',
      //     mask: true,
      //     render: h => h('div', {
      //     }, data[0].message)
      //   });
      // }
    },
    // 异常替换
    async ok() {
      if (this.tableConfig.selectionData.length == 0) {
        this.$Message.warning('请添加并选择替换商品！');
        return;
      }
      const SOURCE_ITEM_IDS = this.componentData.ids
      const REPLACE_SKU_IDS = this.tableConfig.selectionData.map(i => i.skuId)
      const param = {
        SOURCE_ITEM_IDS,
        REPLACE_SKU_IDS,
      };
      try {
        const { data: { code, message, data } } = await this.service.orderCenter.replaceSku(param);
        if (code == 0) {
          this.$Message.success(message)
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.$children[1].refresh()
        }
      } finally {}
    }
  }
};
